import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { ApiClient } from '@/lib/api-client';

interface RequireAuthProps {
  children: ReactNode;
}

function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (!payload.exp) return false;
    // Add 30s buffer to avoid edge-case redirects on nearly-expired tokens
    return Date.now() >= payload.exp * 1000 - 30_000;
  } catch {
    return true;
  }
}

export function RequireAuth({ children }: RequireAuthProps) {
  const token = ApiClient.getToken();
  if (!token || isTokenExpired(token)) {
    ApiClient.clearToken();
    return <Navigate to="/sign-in" replace />;
  }
  return <>{children}</>;
}
